import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import React from "react";
import { withRouter } from "react-router-dom";
import { Col, Input, Label, Row } from "reactstrap";
import BaseButtonWithIconAndTooltip from "../../../../toolkit/baseButtonWithIconAndTooltip";
import BaseInput from "../../../../toolkit/baseInput";
import { LineaPagoConfig } from "./LineaPagoModalMultiple";
import s from "./styles.scss";

interface Props {
  index: number;
  allowTokenize: boolean;
  lineaPago: LineaPagoConfig;
  msiCatalog: any[];
  updateLineaPago: (lineaPago: LineaPagoConfig, index: number) => any;
  deleteLineaPago: (lineaPago: LineaPagoConfig, index: number) => any;
}

class LineaPagoModalMultipleRow extends React.Component<Props> {
  render() {
    const {
      index,
      allowTokenize,
      lineaPago: lp,
      msiCatalog,
      updateLineaPago,
      deleteLineaPago
    } = this.props;

    return (
      <Row
        key={index + "-lpmr"}
        className={`m-3 p-2  ${index % 2 == 0 ? "border" : "border-0"} rounded`}
      >
        {!!allowTokenize && (
          <Col>
            <div>
              <Label className={s.label} for="horaInicial">
                Tokenizar tarjeta para envío a CAT
              </Label>
            </div>
            <div className="pl-4 mt-2">
              <Label check>
                <Input
                  type="checkbox"
                  checked={lp.tokenizar}
                  onChange={e => {
                    const value = e.target.checked;
                    if (!!updateLineaPago) {
                      updateLineaPago({ ...lp, tokenizar: value }, index);
                    }
                  }}
                />
                Registrar medio de pago principal
              </Label>
            </div>
          </Col>
        )}

        <Col>
          <BaseInput
            type="select"
            label="Meses sin intereses"
            name="msiValue"
            id="msiValue"
            options={msiCatalog}
            value={lp.msi}
            onChange={e => {
              const value = e.target.value;
              if (!!updateLineaPago) {
                updateLineaPago({ ...lp, msi: value }, index);
              }
            }}
          />
        </Col>
        <Col xs="4">
          <BaseInput
            label={"Monto"}
            name="lpAmoutn"
            id="lpAmoutn"
            type="text"
            placeholder="Monto"
            value={lp.monto || 0}
          />
        </Col>
        <Col xs="1">
          {index > 0 && (
            <BaseButtonWithIconAndTooltip
              id={`delete-lpmr-${index}`}
              icon={faTimesCircle}
              tooltipTitle=" Eliminar"
              toolTipPlacement="left"
              onClick={() => {
                if (!!deleteLineaPago) {
                  deleteLineaPago({ ...lp }, index);
                }
              }}
            />
          )}
        </Col>
      </Row>
    );
  }
}

export default withRouter(withStyles(s)(LineaPagoModalMultipleRow));
